import React, { useEffect, useState } from 'react';
import "./navigation.css"
import HeaderLogo from '../../assets/mainlogo.png';
import { Link } from 'react-router-dom';
import { FaShoppingBasket, FaSearch } from "react-icons/fa";
import { useSelector } from 'react-redux';

function TopNavigation() {

  const [searchWord, setSearchWord]                               = useState("");
  const [wantToSearch, setWantToSearch]                           = useState(false);
  // Access the cart items from Redux store
  const cartItems                                                 = useSelector((state) => state.cart.items);
  const totalQuantity                                             = cartItems.reduce((total, item) => total + item.quantity, 0);

  useEffect(() => {

  },[])
  const handleUpdateSearchWord = (e) => {

    console.log(e.target.value);
    setSearchWord(e.target.value);
  }
  const closeSearchingDialogue = () =>{
    setWantToSearch(false);
    setSearchWord("");
  } 

  return (
    <nav className="navbar navbar-expand-lg bd-dark">
  <div className="container-fluid">
    
    <Link to="/" className="navbar-brand"> 
        <img src={HeaderLogo} className="logo-one" alt="Stephenson Adventures" />
    </Link>
    <div className="searchitem-nav">
      <div className="item-middle">
          <button className="btn btn-mid-top " onClick={() => setWantToSearch(true)}>
            <FaSearch />     
          </button>
      </div>
      <div className="item-middle">
          <Link to="/cart" className="btn btn-mid-top ">
            <FaShoppingBasket /> 
            <div className="basketTotal">{totalQuantity}</div>
          </Link>
      </div>
    </div>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse " id="navbarNav">
      <ul className="navbar-nav ms-auto">
        <li className="nav-item">
          <Link className="nav-link" to="/shop">Shop</Link>
        </li>        
      </ul>
    </div>
  </div>
  {
    wantToSearch && (
      <div className="searchOverlay">
        <div className="content-search">
              <div className="input-search-area">
                  <div className="item-srch search-icon">
                    <div className="seaching-icon">
                      <FaSearch/>
                    </div>
                  </div>
                  <input type="text" className="txt-search" onChange={e => handleUpdateSearchWord(e)} placeholder="Search for Tour" />
                  <div className="item-srch search-close">
                    <button className="btn btn-no-style btn-closing " onClick={() => closeSearchingDialogue()}>Close</button>
                  </div>
              </div>
        </div>
      </div>
    )
  }
  
</nav>
  )
}

export default TopNavigation